enum UserRole {
  ADMIN = 'ROLE_ADMIN',
  DEALER = 'ROLE_DEALER',
  COUNTRYMANAGER = 'ROLE_COUNTRY_ADMIN',
  DEALERADMIN = 'ROLE_DEALER_ADMIN',
}

export default UserRole;
